module.exports = __webpack_public_path__ + "static/YYAF-df58d2fe19020fc88496335c8c8fd086.jpeg";